// Types
import { RootState } from 'types/RootState.types';

import { isCollectPlusRelatedType } from './getCollectPlusRelatedStores';
import { checkIsUkMobileNumber } from '../address/addressHelpers';

export function ukMobileNumberRequired(state: RootState) {
  const {
    clickAndCollect: {
      selectedCollectionPoint: {
        ownerId = 0,
      } = {},
      isInitialSelection = false,
    } = {},
    user: {
      defaultAddress: {
        phoneNumber: defaultContactPhoneNumber = '',
      } = {},
    } = {},
  } = state ?? {};

  const isCollectPlus = isCollectPlusRelatedType(ownerId);

  return !!(
    isCollectPlus &&
    isInitialSelection &&
    defaultContactPhoneNumber &&
    !checkIsUkMobileNumber(defaultContactPhoneNumber));
}
